// "0470 12 34 56" + 32 → "+32 470 12 34 56", what Ui::Form::PhoneFieldComponent
// sends for the picked country. Numbers with a prefix, and French ones (the
// server default), are left as typed.
export function internationalPhone (value, dialCode) {
  const phone = value.trim()
  if (phone === "" || !dialCode || dialCode === "33" || /^(\+|00)/.test(phone)) return value

  return `+${dialCode} ${phone.replace(/^0/, "")}`
}
